import React, { Component } from 'react';
import {
    SimpleForm,
    TextInput,
    translate,
    FileInput,
    FormDataConsumer,
    Confirm,
    SelectArrayInput,
    required, NumberInput
} from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { change, submit } from 'redux-form';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import RichTextInput from 'ra-input-rich-text';

import { isRequired } from '~utils/inputValidations';
import FieldGroup from '~components/FieldGroup';
import FileLinkField from '~components/FileLinkField';
import { LeaveGuardContext } from '~components/Breadcrumbs';
import { IirsaCountriesService } from '~config/services/iirsa_countries.service';

import DynamicMap from '../../Acciones/components/DynamicMap';
import './styles.scss';

import styles from './styles';

const VolverButton = props => (
    <>
        <Button style={styles.volverButton} onClick={props.onVolverClick}>
            <svg style={styles.chevron} viewBox="0 0 32 32" class="icon icon-chevron-left">
                <path
                    fill="#3f51b5"
                    d="M14.19 16.005l7.869 7.868-2.129 2.129-9.996-9.997L19.937 6.002l2.127 2.129z"
                />
            </svg>
            Volver
        </Button>
        <Confirm
            isOpen={props.showConfirm}
            title="¿Desea salir del formulario?"
            content="Los cambios realizados se perderán"
            confirm="Si"
            confirmColor="primary"
            cancel="Cancelar"
            onConfirm={props.onVolverConfirm}
            onClose={props.onVolverCancel}
        />
    </>
);

const toolbarOptions = [['bold', 'italic', 'underline', 'link'], [{ list: 'bullet' }]];

class TerritorioForm extends Component {
    state = {
        countries: [],
        showConfirm: false
    };

    firstForm = null;
    hasChanged = false;

    constructor() {
        super();

        const cs = new IirsaCountriesService();
        cs.get_la().then(r => {
            let data = r.data;
            data.sort((a, b) => (a.name > b.name ? 1 : -1));
            this.setState({ countries: data });
        });
    }

    validateForm = values => {
        const errors = {};
        if (!values.countries || values.countries.length == 0) {
            errors.countries = ['Debe seleccionar al menos un país'];
        }
        return errors;
    };

    static contextType = LeaveGuardContext;

    componentDidMount() {
        this.context.current = this.requestLeave;
    }

    componentWillUnmount() {
        if (this.context.current === this.requestLeave) {
            this.context.current = null;
        }
    }

    // Shared by Volver and the breadcrumb links: confirm first if the form has changes.
    requestLeave = path => {
        if (this.hasChanged) {
            this.setState({ showConfirm: true, pendingPath: path });
        } else {
            this.props.history.push(path);
        }
    };

    onVolverClick = () => this.requestLeave('/territories');

    onVolverConfirm = () => {
        this.props.history.push(this.state.pendingPath);
    };

    onVolverCancel = () => {
        this.setState({ showConfirm: false });
    };

    isCreateForm() {
        return this.props.location?.pathname.endsWith('/create');
    }

    render() {
        return (
            <>
                <VolverButton
                    showConfirm={this.state.showConfirm}
                    onVolverClick={this.onVolverClick}
                    onVolverConfirm={this.onVolverConfirm}
                    onVolverCancel={this.onVolverCancel}
                />
                <SimpleForm validate={this.validateForm} {...this.props}>
                    {this.children}

                    <FormDataConsumer>
                        {data => {
                            if (!this.firstForm) {
                                this.firstForm = data;
                            } else {
                                if (!(JSON.stringify(data) === JSON.stringify(this.firstForm))) {
                                    this.hasChanged = true;
                                }
                            }
                        }}
                    </FormDataConsumer>

                    <FieldGroup
                        label="fieldGroups.routeInformation"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        <div>
                            <FormDataConsumer>
                                {({formData}) => (
                                    <SelectArrayInput
                                        source="countries"
                                        label={'Paises (*)'}
                                        value={formData?.countries}
                                        choices={this.state.countries}
                                        validate={isRequired}
                                        className={'colInput'}
                                    />
                                )}
                            </FormDataConsumer>
                        </div>
                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.routeEs"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        <TextInput source="name" validate={isRequired} className={'colInput'} label={'Nombre'}/>
                        <div className={'colInputContainer'}>
                            <label style={styles.inputLabel}>Descripción (*)</label>
                            <RichTextInput source="description" toolbar={toolbarOptions} validate={isRequired}/>
                        </div>
                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.routeEn"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        <TextInput source="nameEn" className={'colInput'} label={'Name (EN)'}/>
                        <div className={'colInputContainer'}>
                            <label style={styles.inputLabel}>Description (EN)</label>
                            <RichTextInput source="descriptionEn" toolbar={toolbarOptions} />
                        </div>
                    </FieldGroup>

                    <FieldGroup
                        label="fieldGroups.routePt"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}
                        flex={false}
                    >
                        <TextInput source="namePt" className={'colInput'} label={'Nome (PT)'}/>
                        <div className={'colInputContainer'}>
                            <label style={styles.inputLabel}>Descrição (PT)</label>
                            <RichTextInput source="descriptionPt" toolbar={toolbarOptions} />
                        </div>
                    </FieldGroup>


                    <FieldGroup
                        label="fieldGroups.routeMap"
                        formClassName={this.props.classes.borderBottom}
                        titleColumn={false}>

                        <FileInput source="kmz" accept={[".kml", ".kmz", ".geojson"]} label={'Archivo .kmz/.geojson (*)'} validate={required("Debe adjuntar un mapa para el territorio")}>
                            <FileLinkField />
                        </FileInput>

                        <NumberInput source="dynamic_center_latitude" defaultValue={1}
                                     validate={[required("Debe posicionar el mapa")]}/>
                        <NumberInput source="dynamic_center_longitude" defaultValue={1}
                                     validate={[required("Debe posicionar el mapa")]}/>
                        <NumberInput source="dynamic_map_zoom" defaultValue={1}
                                     validate={[required("Debe posicionar el mapa")]}/>

                        <div style={{margin: 'auto'}}>
                            <FormDataConsumer>
                                {({ formData }) =>
                                    (formData && formData.kmz) ?
                                        <>
                                            <h3>Ajustar mapa</h3>
                                            <DynamicMap
                                                kml={formData.kmz}
                                                change={this.props.change}
                                                dynamic={true}
                                                centerLat={formData.dynamic_center_latitude}
                                                centerLng={formData.dynamic_center_longitude}
                                                zoom={formData.dynamic_map_zoom}
                                                change={this.props.change}
                                            />
                                        </>
                                        :
                                        <></>
                                }
                            </FormDataConsumer>
                        </div>
                    </FieldGroup>
                </SimpleForm>
            </>
        );
    }
}

const mapDispatchToProps = { change, submit };

TerritorioForm.propTypes = {
};

export default withRouter(
    withStyles(styles)(
        connect(
            state => ({}),
            mapDispatchToProps
        )(translate(TerritorioForm))
    )
);
